<template>
    <div>
        <div class="row">
            <h1 class="page-title page-title--category">Brands</h1>
        </div>

        <div class="row brands-filter filter">
            <form>
                <div class="group-filter group-filter--left">
                    <div class="form-field form-field__select">
                        <label for="partner">Brand</label>
                        <input
                            type="text"
                            v-model="searchRequest"
                            @input="search"
                            id="partner"
                        />
                    </div>
                </div>
            </form>
            <div class="form-field form-field--button form-field--button-new">
                <a href="/brands/create" class="btn btn--gray">
                    <i class="icon icon-plus"></i>Add brand</a
                >
                <button
                    @click="openColumnsModal"
                    type="button"
                    class="btn btn--gray"
                >
                    Edit column view
                </button>
            </div>
        </div>

        <div class="row brands-pagination">
            <!-- <div class="columns">
                <button class="btn btn--icon-left">
                    <i class="icon icon-filter"></i> Select columns
                </button>
            </div> -->
        </div>

        <div class="row brands-table">
            <div class="table-wrap">
                <table class="table">
                    <thead>
                        <tr
                            v-if="current_columns && current_columns.length > 0"
                        >
                            <th
                                v-for="col_obj in current_columns
                                    .filter((c) => c.status === 'show')
                                    .sort((a, b) => a.position - b.position)"
                                v-bind:key="'col_table_th_' + col_obj.id"
                                @click="sortData(col_obj.slug)"
                            >
                                <span
                                    v-if="lastSort == col_obj.slug"
                                    :class="
                                        descending &&
                                        lastSort == col_obj.slug &&
                                        'sort-icon--desc'
                                    "
                                    ><i class="icon icon-down-arrow"></i
                                ></span>
                                <div
                                    :style="
                                        col_obj.id === 4 &&
                                        'word-spacing: normal'
                                    "
                                    v-html="col_obj.name"
                                ></div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="loading">
                            <td colspan="10">
                                <clip-loader
                                    :loading="loading"
                                    :color="'#ec4657'"
                                    :size="'45px'"
                                ></clip-loader>
                            </td>
                        </tr>
                        <tr v-else-if="!items.length && !loading">
                            <td colspan="10"><center>No data</center></td>
                        </tr>
                        <tr
                            v-else-if="
                                searchRequest.length >= 3 && filterItems.length
                            "
                            v-for="item in filterItems"
                            :key="item.id"
                        >
                            <td
                                v-for="_col in current_columns.filter(
                                    (c) => c.status === 'show'
                                )"
                                v-bind:key="'col_table_partner_' + _col.id"
                            >
                                <a
                                    v-if="_col.is_link && item[_col.slug].url"
                                    :href="item[_col.slug].url"
                                    :style="
                                        item.status == 'Overdue'
                                            ? 'color:red'
                                            : ''
                                    "
                                    >{{ item[_col.slug].name }}</a
                                >
                                <p
                                    v-else-if="
                                        _col.is_link && !item[_col.slug].url
                                    "
                                    :style="
                                        item.status == 'Overdue'
                                            ? 'color:red'
                                            : ''
                                    "
                                >
                                    -
                                </p>
                                <button
                                    v-else-if="_col.slug === 'action'"
                                    class="btn btn--icon"
                                    @click="deletePartner(item.id)"
                                    type="button"
                                >
                                    <i class="icon icon-trash"></i>
                                </button>
                                <p
                                    v-else
                                    :class="
                                        !item[_col.slug] ||
                                        item[_col.slug] === '-' ||
                                        item[_col.slug] <= 0
                                            ? 'color-of-null'
                                            : ''
                                    "
                                >
                                    {{ item[_col.slug] || "-" }}
                                </p>
                            </td>
                        </tr>
                        <tr
                            v-else-if="
                                !filterItems.length && searchRequest.length >= 3
                            "
                        >
                            <td colspan="16"><center>No data</center></td>
                        </tr>
                        <tr v-else v-for="item in items" :key="item.id">
                            <td
                                v-for="_col in current_columns.filter(
                                    (c) => c.status === 'show'
                                )"
                                v-bind:key="'col_table_partner_' + _col.id"
                            >
                                <a
                                    v-if="_col.is_link && item[_col.slug].url"
                                    :href="item[_col.slug].url"
                                    :style="
                                        item.status == 'Overdue'
                                            ? 'color:red'
                                            : ''
                                    "
                                    >{{ item[_col.slug].name }}</a
                                >
                                <p
                                    v-else-if="
                                        _col.is_link && !item[_col.slug].url
                                    "
                                    :style="
                                        item.status == 'Overdue'
                                            ? 'color:red'
                                            : ''
                                    "
                                >
                                    -
                                </p>
                                <button
                                    v-else-if="_col.slug === 'action'"
                                    class="btn btn--icon"
                                    @click="deletePartner(item.id)"
                                    type="button"
                                >
                                    <i class="icon icon-trash"></i>
                                </button>
                                <p
                                    v-else
                                    :class="
                                        !item[_col.slug] ||
                                        item[_col.slug] === '-' ||
                                        item[_col.slug] <= 0
                                            ? 'color-of-null'
                                            : ''
                                    "
                                >
                                    {{
                                        item[_col.slug] ? item[_col.slug] : "-"
                                    }}
                                </p>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="row brands-pagination jus-c--right">
            <!-- {{ $brands->links() }} -->
        </div>
        <Column_Modal
            :is_show="showModalColumns"
            :__columns="current_columns"
            :selectColumn="selectColumn"
            :closeModal="closeModal"
            :selected_col="selected_col"
            v-if="showModalColumns"
        ></Column_Modal>
    </div>
</template>

<script>
import ClipLoader from "vue-spinner/src/ClipLoader.vue";
import axios from "axios";
import * as sortArray from "../../parts/sort-array";
import Column_Modal from "../ColumnModal";

export default {
    name: "Brands",
    props: ["columns"],
    components: {
        ClipLoader,
        Column_Modal,
    },
    data() {
        return {
            //selectedPartner: null,
            loading: false,
            items: [],
            filterItems: [],
            descending: false,
            searchRequest: "",
            lastSort: "date",
            showModalColumns: false,
            selected_col: null,
            current_columns: [],
            filter_columns: [],
        };
    },

    mounted() {
        this.current_columns = JSON.parse(JSON.stringify(this.columns));

        this.fetchData();
    },

    methods: {
        /*changeSelect(e) {
            const id = e.id;

            if (id) {
                this.selectedPartner = id;
                this.filterData(id);
            } else {
                this.selectedPartner = null;
                this.filterItems = [];
            }
        },*/
        setValue(e) {
            const name = e.target.name;
            const value = e.target.value;

            this[name] = value;

            this.fetchData();
        },
        checkboxValue(e) {
            if (e.target.checked) {
                this.selectedStatus.push(e.target.value);
            } else {
                this.selectedStatus = this.selectedStatus.filter(
                    (i) => i != e.target.value
                );
            }

            this.fetchData();
        },
        formatDatePeriod(date) {
            const options = { year: "numeric", month: "long" };
            const _date = new Date(date);

            return _date.toLocaleDateString("en-GB", options);
        },
        deletePartner(id) {
            this.loading = true;

            if (confirm("Do you really want to delete?")) {
                axios
                    .post("/brands/delete", {
                        id: id,
                    })
                    .then((res) => {
                        this.loading = false;
                        if (res.data.isSuccess) {
                            this.fetchData();
                            this.searchRequest = "";
                            this.filterItems = [];
                        }
                    })
                    .catch((err) => {
                        if (err.response) {
                            // The client was given an error response (5xx, 4xx)
                            alert(err.response.data.message);
                        }
                        this.loading = false;
                    });
            } else {
                this.fetchData();
            }
        },
        fetchData() {
            this.loading = true;

            axios
                .post("/brands/getList")
                .then((res) => {
                    this.loading = false;
                    if (res.data.length) {
                        this.items = this.reformatDataByColumns(res.data);
                    } else {
                        this.items = [];
                    }
                })
                .catch((err) => {
                    console.error("Fetch brands error", err);
                    this.loading = false;
                });
        },
        /*filterData(id = null) {
            this.filterItems = this.items.filter((item) => item.id === id);
        },*/
        search() {
            if (this.searchRequest.length >= 3) {
                this.filterItems = this.items.filter((item) =>
                    item.name.name
                        .toLowerCase()
                        .includes(this.searchRequest.toLowerCase())
                );
            }
        },
        sortData(sortBy) {
            let self = this;
            if (self.lastSort !== sortBy) self.descending = false;
            self.lastSort = sortBy;
            console.log(sortBy);
            switch (sortBy) {
                case "id":
                    self.items = self.items.sort(
                        sortArray.sortNumber("id", self.descending)
                    );
                    break;
                case "name":
                    self.items = self.items.sort(
                        sortArray.sortText("name", self.descending, (a) =>
                            a.name.toUpperCase()
                        )
                    );
                    break;
                case "contact":
                    self.items = self.items.sort(
                        sortArray.sortText("contact", self.descending)
                    );
                    break;
                case "referred_by":
                    self.items = self.items.sort(
                        sortArray.sortText(
                            "referred_by",
                            self.descending,
                            (a) => a.toUpperCase(),
                            "name"
                        )
                    );
                    break;
                case "date":
                    self.items = self.items.sort(
                        sortArray.sortDate("date", self.descending)
                    );
                    break;
                case "year_deals":
                    self.items = self.items.sort(
                        sortArray.sortNumber("year_deals", self.descending)
                    );
                    break;
                case "total_deals":
                    self.items = self.items.sort(
                        sortArray.sortNumber("total_deals", self.descending)
                    );
                    break;

                case "collected_commission":
                    self.items = self.items.sort(
                        sortArray.sortMoney(
                            "collected_commission",
                            self.descending
                        )
                    );
                    break;
                case "paid_commission":
                    self.items = self.items.sort(
                        sortArray.sortMoney("paid_commission", self.descending)
                    );
                    break;
                case "profit":
                    self.items = self.items.sort(
                        sortArray.sortMoney("profit", self.descending)
                    );
                    break;
            }
            self.descending = !self.descending;
        },
        // MODAL COLUMNS
        reformatDataByColumns(__items = []) {
            try {
                if (__items.length >= 1) {
                    const newFormatData = [];
                    if (this.current_columns.length >= 1) {
                        __items.forEach((item) => {
                            const tempObj = {};
                            this.current_columns
                                .sort((a, b) => a.position - b.position)
                                .forEach((c) => {
                                    if (c.status === "hidden") {
                                        return;
                                    }
                                    tempObj[`${c.slug}`] = item[c.slug];
                                    if (c.slug === "name") {
                                        tempObj[`name`] = {
                                            name: item["name"],
                                            url: item["url"],
                                        };
                                    }
                                    if (c.slug === "referred_by") {
                                        tempObj[`referred_by`] = {
                                            name: item["referredBy"].name,
                                            url: item["referredBy"].url,
                                        };
                                    }
                                });

                            newFormatData.push(tempObj);
                        });
                        return newFormatData;
                    }
                }

                return [];
            } catch (err) {
                console.error("reformatDataByColumns error", err);
            }
        },
        openColumnsModal() {
            this.showModalColumns = true;
            document.querySelector("html").style = "overflow-y: hidden";
            document.querySelector("body").style =
                "overflow-y: hidden; margin-right: 16px";
        },
        async closeModal(items = []) {
            await axios
                .post("/brands/updateColumns", {
                    columns: items,
                })
                .then(() => {
                    this.showModalColumns = false;
                    this.current_columns.length = 0;
                    this.current_columns = JSON.parse(JSON.stringify(items));
                    document.querySelector("html").style = "";
                    document.querySelector("body").style = "";
                })
                .catch((err) => {
                    console.error("Axios update columns error", err);
                });
        },
        selectColumn(col) {
            this.selected_col = col;
        },
    },
};
</script>
